import { useUIStore } from '@/core/stores/ui.store';

export function useDateFormat() {
  const dateFormat = useUIStore((s) => s.dateFormat);
  const timeFormat = useUIStore((s) => s.timeFormat);

  return {
    dateFormat,
    timeFormat,
  };
}
